import React, { useEffect, useState } from "react";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { SeachSection } from "../../components/SpearParts/Layouts/SeachSection";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  searchPart,
  getCompleteData,
  getItems,
} from "../../actions/HomeAction";
import NoData from "../../components/NoData/Index";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import { toTitleCase } from "../../components/utils/StringUtil";
import Axios from "../../axios/axios";
import Middle from "../../components/SpearParts/Layouts/Middle";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

export default function Category() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [parts, setParts] = useState([]);
  const [spareCategory, setSpareCategory] = useState([]);
  const [spareBrand, setSpareBrand] = useState([]);
  const [spareModels, setSpareModels] = useState([]);
  const [region, setRegion] = useState([]);
  const [years, setYears] = useState([]);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const uniqueParts = [
    ...new Map(
      parts.map((p) => [
        `${p.brandId}_${p.modelId}_${p.engine}_${p.regionId}_${p.transmissionType}_${p.year}`,
        p,
      ])
    ).values(),
  ];

  useEffect(() => {
    if (location.state) {
      setSpareCategory(location.state.spareCategory || []);
      setSpareBrand(location.state.spareBrand || []);
      setSpareModels(location.state.spareModels || []);
      setRegion(location.state.region || []);
      setYears(location.state.years || []);
    } else {
      getCompleteData(setSpareModels, setSpareBrand, setSpareCategory);
      getItems(setRegion);
    }
  }, [location.state]);

  const filters = {
    brandId: searchParams.get("brandId"),
    modelId: searchParams.get("modelId"),
    year: searchParams.get("year"),
    regionId: searchParams.get("regionId"),
  };

  useEffect(() => {
    const fetchModels = async () => {
      if (filters.brandId) {
        try {
          const res = await Axios.post("/model/modelBybrand", {
            brand: filters.brandId,
          });
          setSpareModels(res.data);
        } catch (error) {
          console.error(error);
          setSpareModels([]);
        }
      }
    };
    fetchModels();
  }, [filters.brandId]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchCategories = async () => {
      const res = await searchPart({ ...filters, page, limit: 15 });
      setCategories(res.categories);
      setTotalPages(res.totalPages);
    };

    fetchCategories();
  }, [location.search, page]);

  const getBrandName = (brandId) =>
    spareBrand.find((b) => b._id === brandId)?.name || "Unknown Brand";

  const getModelName = (modelId) =>
    spareModels.find((m) => m._id === modelId)?.name || "Unknown Model";

  const getRegionName = (regionId) =>
    region.find((m) => m._id === regionId)?.name || "Unknown Region";

  const getCategoryName = (category) => category?.name || "Unknown Category";

  const CategoryBoxCard = ({ category }) => {
    const hasSubcategories =
      category.subcategories && category.subcategories.length > 0;

    const handleClick = () => {
      const query = new URLSearchParams({
        categoryId: category._id,
        brandId: filters.brandId || "",
        modelId: filters.modelId || "",
        year: filters.year || "",
        regionId: filters.regionId || "",
      }).toString();

      // 👉 Check if subcategories exist
      if (hasSubcategories) {
        navigate(`/subcategory?${query}`, {
          state: {
            subcategories: category.subcategories,
            spareCategory,
            spareBrand,
            spareModels,
            region,
            years,
            filters,
          },
        });
      } else {
        navigate(`/productlist?${query}`, {
          state: {
            spareCategory,
            spareBrand,
            spareModels,
            region,
            years,
            filters,
            selectedCategory: category,
          },
        });
      }
    };

    return (
      <div
        className="category-item"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex flex-column align-items-center">
          {category.images?.length > 0 && (
            <img src={category.images[0]} alt="Category" />
          )}
          <h6>{category.name}</h6>
        </div>
      </div>
    );
  };

  return (
    <div>
      {/* <Header /> */}
      <section id="banner">
        <div className="Main-div">
          <TopNavBar />
          <div className="TopSearchBar">
            <TopSearchBar />
          </div>
          <div className="container">
            <div className="">
              <Middle initialFilters={filters} />
            </div>
            <div
              className=""
              style={{ width: "85%", alignContent: "center", margin: "auto" }}
            >
              <div className="row mt-3">
                <div className="col-lg-12">
                  <button
                    className="back btn btn-light"
                    onClick={() => navigate(-1)}
                    style={{
                      border: "none",
                      backgroundColor: "#dbe4f0ff",
                      padding: "8px 14px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>{" "}
                    Back
                  </button>

                  <div className="table-responsive mt-3">
                    <table className="table product-table">
                      <tbody>
                        <tr>
                          <th style={{ backgroundColor: "#E9EEF4" }}>
                            &nbsp;{" "}
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="category-grid">
                    {categories.length > 0 ? (
                      categories.map((category, idx) => (
                        <CategoryBoxCard key={idx} category={category} />
                      ))
                    ) : (
                      <NoData />
                    )}
                  </div>

                  {totalPages > 1 && (
                    <div className="pagination-container d-flex justify-content-end align-items-center mt-4">
                      <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                      >
                        <i className="fa fa-arrow-left"></i>
                      </button>

                      <span className="mx-3">
                        {page} of {totalPages}
                      </span>

                      <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                      >
                        <i className="fa fa-arrow-right"></i>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
